// project import
import Default from './default';

// ==============================|| PRESET THEME - THEME SELECTOR ||============================== //

const Theme = (colors) => {
  return Default(colors);
};

export default Theme;
